import { defaultColumns, defaultSort } from '../../components/processes/inwardHandlings/columns';

export default {
  state: {
    inwardHandlings: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    inwardHandlings: state => state.inwardHandlings,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setInwardHandlings(state, inwardHandlings) {
      state.inwardHandlings = inwardHandlings;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/inward-handling-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'inward-handling-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&comparetype=${state.sorting.compareType || 'string'}&${state.filterString}`;
        const inwardHandlings = await axios.get('api/inward-handlings' + (query || ''));
        commit('setInwardHandlings', inwardHandlings);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async search({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        return await axios.get('api/inward-handlings/search' + (queryString || ''));
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/inward-handlings/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/inward-handlings', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/inward-handlings', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/inward-handlings/${id}`);
    },
    async createRepresentativeOrder({ commit }, { inwardHandlingId, target_storage_id, comment }) {
      await axios.post(`api/inward-handlings/${inwardHandlingId}/create-representative-order`, {
        target_storage_id,
        comment
      });
    },
    async createCustomerOrder({ commit }, { inwardHandlingId, partner_id }) {
      await axios.post(`api/inward-handlings/${inwardHandlingId}/create-customer-order`, {
        partner_id
      });
    },
    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/inward-handling-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'InwardHandlings'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
